export default {
      id: "i-view-matrix-usage",
      viewBox: "0 0 25 25",
      url: __webpack_public_path__ + "img/sprite.svg#i-view-matrix",
      toString: function () {
        return this.url;
      }
    }